export default () =>
  ({
    wrap: {
      marginTop: '8px',
      position: 'relative',
    },
  }) as const
